import { Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { MediaCarousel } from '../carousel/model/media-carousel.model';

const IMG = '<img default="" src="LINK_IMG" alt="LINK_IMG">';

@Component({
  selector: 'app-thumbnail',
  templateUrl: './thumbnail.component.html',
  styleUrls: ['./thumbnail.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ThumbnailComponent {

  @Input() listThumbnail: Array<MediaCarousel> = [];
  @Input() indexSelected = 0;
  @Input() type: string;

  @Output() sendIndex: EventEmitter<{ index: number }> = new EventEmitter<{ index: number }>();

  clickThumbnail(index) {
    this.indexSelected = index;
    this.sendIndex.emit({ index: this.indexSelected });
  }

  nameImg() {
    if (this.listThumbnail.length > 0) {
      return this.listThumbnail[this.indexSelected].name;
    }
  }

  setHtmlImg(link: string) {
    return IMG.replace(/LINK_IMG/g, link);
  }

}
